module.exports = __webpack_public_path__ + "assets/img/3.54ca577b.png";